import { render, staticRenderFns } from "./Manage-Organisation.vue?vue&type=template&id=ad62e39e"
import script from "./Manage-Organisation.vue?vue&type=script&lang=js"
export * from "./Manage-Organisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports